import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./AddScoreForm.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AddScoreForm = ({ open, onClose, data }) => {
  const navigate = useNavigate();
  const [secondModal, setSecondModal] = useState(false);
  const [formData, setFormData] = useState({
    user_id: data.user_id,
    score: "",
    admin_id: sessionStorage.getItem("admin_id") || "Admin",
    created_at: moment().format("YYYY-MM-DD HH:mm:ss")
  });

  const handleScoreChange = (e) => {
    const value = e.target.value;
    
    if (value === "") {
      setFormData(prev => ({ ...prev, score: "" }));
      return;
    }

    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      setFormData(prev => ({
        ...prev,
        score: value
      }));
    } else {
      toast.error("Please enter", { 
        position: "top-center",
        autoClose: 2000
      });
    }
  };

  const handleSubmit = async () => {
    const scoreNum = parseFloat(formData.score);
    
    if (formData.score === "" || isNaN(scoreNum)) {
      toast.warn("Please enter a score before submitting!", { position: "top-center" });
      return;
    }

    

    try {
      await axios.post(
        `https://batak-pro-server.xicsolutions.in/score/storeUserScore`,
        formData
      );
      toast.success("Successfully added score", { autoClose: 3000 });
      setTimeout(() => {
        navigate("/adminIndex");
      }, 3000);
    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message, { autoClose: 3000 });
      }
      console.error("Error failed to add score:", err);
    }
  };

  const handleSecondModalOpen = () => {
    setSecondModal(true);
  };

  const handleModalClose = () => {
    setSecondModal(false);
  };

  const dialogStyle = {
    borderRadius: "20px",
    padding: "20px",
    maxWidth: "30rem",
    background: "rgba(12, 12, 12, 0.27)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgb(255, 255, 255)",
  };
  const dialogStyleone = {
    borderRadius: "20px",
    padding: "20px",
    maxWidth: "25rem",
    background: "rgba(12, 12, 12, 0.27)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgb(255, 255, 255)",
  };

  const titleStyle = {
    textAlign: 'center',
    color: 'white',
    fontWeight: 'bold',
    letterSpacing: '1px',
    fontSize: '24px',
    borderRadius: '10px',
    padding: '15px'
  };

  const inputStyle = {
    width: '130px',
    height: '50px',
    padding: '8px 16px',
    fontSize: '1.1rem',
    border: '1px solid rgb(255, 255, 255)',
    borderRadius: '20px',
    outline: 'none',
    textAlign: 'center',
    background: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(5px)',
    color: 'white',
    transition: 'all 0.3s ease',
  };

  const actionsStyle = {
    justifyContent: 'center',
    gap: "1rem",
    padding: '20px',
    borderRadius: '10px',
    margin: '20px 0 0 0'
  };

  const cancelButtonStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "white",
    borderRadius: "20px",
    padding: "10px 20px",
    fontWeight: "bold",
    border: "1px solid white",
    backdropFilter: "blur(5px)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)"
    }
  };

  const submitButtonStyle = {
    backgroundColor: "rgba(96, 0, 210, 0.8)",
    color: "#fff",
    borderRadius: "20px",
    padding: "10px 20px",
    fontWeight: "bold",
    backdropFilter: "blur(5px)",
    border: "1px solid white",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(96, 0, 210, 0.9)"
    }
  };

  return (
    <div>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="sm" 
        fullWidth 
        PaperProps={{ style: dialogStyle }}
      >
        <DialogTitle style={titleStyle}>
          Enter Score
        </DialogTitle>
        <DialogContent>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '20px', 
            fontSize: '18px', 
            fontWeight: 'bold', 
            color: 'white',
            padding: '10px',
            borderRadius: '10px'
          }}>
            Score: {formData.score !== "" ? formData.score : "Not selected"}
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <div style={{ fontSize: '20px', color: 'white' }}>
              Enter a score 
            </div>
            <input
              type="text"
              value={formData.score}
              onChange={handleScoreChange}
              placeholder="Enter Score"
              style={inputStyle}
            />
          </div>
        </DialogContent>
        <DialogActions style={actionsStyle}>
          <Button onClick={onClose} variant="outlined" style={cancelButtonStyle}>
            Cancel
          </Button>
          <Button onClick={handleSecondModalOpen} variant="contained" style={submitButtonStyle}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog 
        open={secondModal} 
        onClose={handleModalClose} 
        maxWidth="sm" 
        fullWidth 
        PaperProps={{ style: dialogStyleone }}
      >
        <DialogTitle style={titleStyle}>
          Confirm Score
        </DialogTitle>
        <DialogContent>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '20px', 
            fontSize: '18px', 
            fontWeight: 'bold', 
            color: 'white',
            padding: '10px',
            borderRadius: '10px'
          }}>
            Score: {formData.score}
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <input
              type="text"
              value={formData.score}
              disabled
              style={inputStyle}
            />
          </div>
        </DialogContent>
        <DialogActions style={actionsStyle}>
          <Button onClick={handleModalClose} variant="outlined" style={cancelButtonStyle}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" style={submitButtonStyle}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

export default AddScoreForm;